import React from 'react';
import LoginForm from '../components/LoginForm';

const LoginPage = ({ onLoginSuccess }) => {
  return <LoginForm onLoginSuccess={onLoginSuccess} />;
};

export default LoginPage;